import { map as Rmap } from "ramda";
import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

interface User {
  id: string;
  name: string;
  email: string;
  status: string;
  permission_level: string;
  password?: string;
}

interface UserState {
  users: User[];
  user: User | {};
}

const emptyUser: User = {
  id: "",
  name: "",
  email: "",
  status: "active",
  permission_level: "field_worker",
  password: "",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    user: {
      ...jsConn.formParams,
    },
  };
};

const itemDetails = {
  pluralName: "users",
  singularName: "user",
};

const state: UserState = {
  users: [],
  user: {},
};

const mutations = {
  LOAD_USERS(state: UserState, payload: User[]) {
    state.users = payload;
  },
  LOAD_USER(state: UserState, payload: User) {
    state.user = payload;
  },
};

const actions = {
  needUsers(context: any, jsConn: JSConn) {
    return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_USERS", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  needUser(context: any, jsConn: JSConn) {
    return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_USER", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  createUser(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_USER", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  updateUser(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .updateItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_USER", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  deleteUser(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);

    return api
      .deleteItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_USER", emptyUser);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  users: (state: UserState) => {
    return state.users;
  },
  usersForTable: (state: UserState) => {
    return state.users;
  },

  user: (state: UserState) => state.user,

  usersForAutocomplete: (state: UserState) => {
    // map over the items and just return a label and an id
    return Rmap(user => {
      return {
        value: user.id,
        label: `${user.name}`,
      };
    }, state.users);
  },
};

const usersModule = {
  state,
  mutations,
  actions,
  getters,
};

export default usersModule;
